import Input from "../../../Input/index.jsx";
import {
  FormDiv,
  DivTextarea,
  DivMain,
  PdfEmbed,
  DragAndDropArea,
  Instructions,
  HiddenFileInput,
  FileInfo,
  FileDetails,
  DragAndDropArea2,
  GoBack,
  InputTextarea,
} from "../style.js";
import Loading from "../../../../utils/Loading/index.jsx";
import { extractDate } from "../../../../utils/dateUtils.js";

const FormSection2 = ({
  isEditMode,
  isRevisaoMode,
  valueInputDateInicio,
  naoComecou,
  handleDataInicioChange,
  progressaoEdit,
  setDataInicio,
  setDataFim,
  valueInputDateFim,
  minimoDateFim,
  handleDataFimChange,
  fileUrlEdit,
  fileUrl,
  loading3,
  dragActive,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileChange,
}) => {
  return (
    <>
      {isRevisaoMode ? null : (
        <FormDiv $border={true} $padding={true}>
          <div style={{ display: "flex", alignItems: "end", gap: "1rem", width: "12rem" }}>
            <Input
              color="#000000"
              widthDiv="9rem"
              placeholdercolor="#000000"
              type="date"
              placeholder="Início da Progressão"
              whiteSpace="nowrap"
              required={true}
              value={valueInputDateInicio}
              disabled={isEditMode ? !naoComecou : false}
              min={new Date().toISOString().split("T")[0]}
              event={handleDataInicioChange}
            />
            {valueInputDateInicio !== extractDate(progressaoEdit?.data_inicio) && isEditMode && (
              <GoBack
                title="Voltar Data Anterior"
                onClick={() => setDataInicio(extractDate(progressaoEdit?.data_inicio))}
              />
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end", gap: "1rem", width: "12rem" }}>
            <Input
              color="#000000"
              widthDiv="15rem"
              placeholdercolor="#000000"
              type="date"
              placeholder="Limite da Entrega"
              whiteSpace="nowrap"
              required={true}
              value={valueInputDateFim}
              min={minimoDateFim}
              disabled={isRevisaoMode}
              event={isEditMode ? (e) => handleDataFimChange(e) : handleDataFimChange}
            />
            {valueInputDateInicio < extractDate(progressaoEdit?.data_fim) &&
              valueInputDateFim !== extractDate(progressaoEdit?.data_fim) &&
              isEditMode && (
                <GoBack
                  title="Voltar Data Anterior"
                  onClick={() => setDataFim(extractDate(progressaoEdit?.data_fim))}
                />
              )}
          </div>
        </FormDiv>
      )}
      <DivMain $isRevisaoMode={isRevisaoMode}>
        {fileUrlEdit ? (
          <PdfEmbed src={fileUrlEdit} title="PDF Viewer" $isRevisaoMode={isRevisaoMode} />
        ) : fileUrl ? (
          loading3 ? (
            <Loading />
          ) : (
            <PdfEmbed src={fileUrl} title="PDF Viewer" $isRevisaoMode={isRevisaoMode} />
          )
        ) : (
          <DragAndDropArea
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            dragActive={dragActive}
          >
            <Instructions>
              {dragActive ? (
                "Solte o arquivo aqui..."
              ) : (
                <p>
                  Arraste (ou clique aqui) um arquivo <strong>PDF</strong> contendo o conteúdo das atividades que os
                  alunos devem realizar para cumprir a progressão parcial. Não esqueça de definir corretamente as datas
                  acima correspondentes ao início e fim da progressão.
                  <br />
                  <br />
                  <p style={{ fontSize: "0.8rem" }}>(O tamanho máximo do arquivo é de 5MB)</p>
                </p>
              )}
            </Instructions>
            <HiddenFileInput type="file" accept=".pdf" onChange={handleFileChange} />
          </DragAndDropArea>
        )}
      </DivMain>
    </>
  );
};

export default FormSection2;
